<template>
  <ul class="bto-sb-pagination">
    <li :class="{ 'bto-sb-pagination-disabled': isInFirstPage }">
      <a :class="{ disabled: isInFirstPage }" @click="onClickFirstPage()" aria-label="Go to first page">{{ t('Pager.First') }}</a>
    </li>
    <li :class="{ 'bto-sb-pagination-disabled': isInFirstPage }">
      <a :class="{ disabled: isInFirstPage }" @click="onClickPreviousPage()" aria-label="Go to previous page">{{ t('Pager.Previous') }}</a>
    </li>
    <li v-for="paginationPage in pages" :key="paginationPage.name" :class="{ 'bto-sb-pagination-active': isPageActive(paginationPage.name)}">
      <a v-if="isPageActive(paginationPage.name)" :aria-label="`Go to page number ${paginationPage.name}`"> {{ paginationPage.name }}</a>
      <a v-else  @click.prevent="onClickPage(paginationPage.name)" :aria-label="`Go to page number ${paginationPage.name}`"> {{ paginationPage.name }}</a>
    </li>
    <li :class="{ 'bto-sb-pagination-disabled': isInLastPage }">
      <a @click="onClickNextPage()" aria-label="Go to next page"> {{ t('Pager.Next') }} </a>
    </li>
    <li :class="{ 'bto-sb-pagination-disabled': isInLastPage }">
      <a @click="onClickLastPage()" aria-label="Go to last page">{{ t('Pager.Last') }}</a>
    </li>
  </ul>
</template>

<script>
  export default {
    name: 'PaginationComponent',
    props: {
      maxVisibleButtons: {
        type: Number,
        required: false,
      },
      totalPages: {
        type: Number,
        required: true,
      },
      currentPage: {
        type: Number,
        required: true
      },
    },
    computed: {
      startPage() {
        if (this.currentPage === 1) {
          return 1;
        }
        if (this.currentPage === this.totalPages) {
          return this.totalPages - this.maxVisibleButtons + 1;
        }
        return this.currentPage - 1;
      },
      endPage() {
        return Math.min(this.startPage + this.maxVisibleButtons - 1, this.totalPages);
      },
      pages() {
        const range = [];
        for (let i = this.startPage; i <= this.endPage; i += 1) {
          if (i > 0) {
            range.push({
              name: i,
              isDisabled: i === this.currentPage
            });
          }
        }
        return range;
      },
      isInFirstPage() {
        return this.currentPage === 1;
      },
      isInLastPage() {
        return this.currentPage === this.totalPages;
      },
    },
    methods: {
      onClickFirstPage() {
        if (this.currentPage > 1) {
          this.$emit('pagechanged', 1);
        }
      },
      onClickPreviousPage() {
        if (this.currentPage > 1) {
          this.$emit('pagechanged', this.currentPage - 1);
        }
      },
      onClickPage(page) {
        this.$emit('pagechanged', page);
      },
      onClickNextPage() {
        if (this.currentPage < this.totalPages) {
          this.$emit('pagechanged', this.currentPage + 1);
        }
      },
      onClickLastPage() {
        if (this.currentPage < this.totalPages) {
          this.$emit('pagechanged', this.totalPages);
        }
      },
      isPageActive(page) {
        return this.currentPage === page;
      },
    },
  };
</script>
